module.exports = __webpack_public_path__ + "img/1 (108).c5edf082.png";